import React, { Component } from 'react'

import {Input,Icon,Row,Col} from "antd";
// model
import SearchTipItem from './model/searchTipItem'
//service
import AppService from "../app.service";

import './style.less'
// const { Search } = Input;

interface iProps {
    mode?: string
}
interface iState {
    searchVisible: boolean,
    searchTipItems: SearchTipItem[],
    showInput: boolean
}

export default class headerSearch extends Component<iProps, iState> {
    private appService: AppService = new AppService();
    state: iState = {
        searchVisible: true,
        searchTipItems: [],
        showInput: false
    }
    // 获取查询提示词 
    querySearchTip = async (e) => {
        let searchText = e.target.value
        if (searchText.trim()) {
            let searchTipItems = await this.appService.querySearchTip(searchText) || []
            this.setState({searchTipItems})
            if (searchTipItems.length) {
                this.setState({searchVisible: true})
            }
        } else {
            this.setState({searchTipItems: []})
        }
    }
    focusInput = (e) => {
        if (e.target.value.trim() && this.state.searchTipItems.length) {
            // this.setState({searchVisible: true})
        }
    }
    // 隐藏
    hideTips = (evt) => {
        let searchTip = document.getElementById('headSearchTip')
        var evt = window.event ? window.event: evt,
        target = evt.srcElement || evt.target;
        if (searchTip && searchTip.contains(target)) {
            this.setState({searchVisible: true})
        } else {
            this.setState({searchVisible: false,showInput: false, searchTipItems: []})
        }
    }
    // 实体项详情
    goAffairDetails = (affair: SearchTipItem) => {
        if (affair && affair.fullname)  {
            this.setState({searchVisible: false})
            window.open(window.location.origin + `/fe-pc/b/fe_datasearch/searchResult/${affair.fullname}`, '_blank')
        }
        else{
            return
        }
    }
    componentDidMount () {
        document.addEventListener('click', this.hideTips.bind(this), true);
    }
    render() {
        let {mode = 'dark'} = this.props
        let { searchVisible, searchTipItems = [], showInput } = this.state
        return (
            <div className={ mode === 'dark' ? 'header_search' : 'header_search_light' } >
                {/* {
                    !showInput && 
                    <div style={{boxSizing: 'border-box', display: 'flex'}}>
                        <Icon onClick={() => this.setState({showInput: true})} type="search" style={{ color: '#fff', fontSize: 18, cursor: 'pointer' }}></Icon>
                    </div>
                } */}
                {/* {showInput && <Icon type="close-circle" theme="filled" style={{color: '#f00', fontSize:14, position:'absolute', right: 0, top: 2}} />} */}
                <div id="headSearchTip">
                    <Input
                        style={{ color: mode === 'dark' ? '#fff' : '#333' }}
                        placeholder="搜索"
                        onChange={this.querySearchTip}
                        onFocus={this.focusInput}
                        prefix={<Icon type="search" style={{ color: mode === 'dark' ? '#fff' : '#333' }} />}
                    />
                    {searchVisible &&
                        <div className="searchIndex_tip" >
                            {
                                searchTipItems.map((item, index) => {
                                    return index< 5 && <Row  key={item.no} className="searchIndex_tip_item" onClick={this.goAffairDetails.bind(null, item)}>
                                        <Col span={12} className="searchIndex_tip_item_name">
                                            <Icon type="search" />
                                            {item.fullname}
                                        </Col>
                                        <Col span={12} className="searchIndex_tip_item_affair">
                                            <div>
                                                {item.affairName}
                                            </div>
                                        </Col>
                                    </Row>
                                })
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}
